import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  locale: string;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "TabFranchiseOpportunity",
  uniqId: "tab_franchise_opportunity",
})((theme, { params }, classes) => {
  return {
    contentContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: 1000,
      justifyContent: "flex-start",
      alignItems: "center",
    },

    instruction: {
      "& p": {
        color: "#333",
        textAlign: "center",
        fontFamily: params.locale === "en-US" ? "Montserrat" : params.locale === "zh-CN" ? "Noto Sans SC" : "Noto Sans TC",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "200%",
        letterSpacing: params.locale === "en-US" ? 0 : "3.6px",
        display: "inline",
      },

      "& a": {
        color: "#4B2884",
        fontFamily: params.locale === "en-US" ? "Montserrat" : params.locale === "zh-CN" ? "Noto Sans SC" : "Noto Sans TC",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "200%",
        display: "inline",
      },
    },
  };
});

export default useStyles;
